/**
 * @generated SignedSource<<2b3ce8fa8051cb4f4a8e8ed6cec56b97>>
 * @relayHash ef0c8a2efcdb424a83f78665f0acae46
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 985c157aa565f03e81496dc29b329e2ae1f91e0760c67bd74b9fcde8e1c8c447

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceApprovalTransitionType = "DIRECTED" | "INITIAL" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceReviewerDecisionState = "PENDING_REVIEW" | "REVIEWER_APPROVED" | "REVIEWER_DENIED" | "REVIEW_CANCELED" | "%future added value";
export type ConfluenceWorkflowReviewStatus = "APPROVED" | "CANCELED" | "DENIED" | "PENDING" | "%future added value";
export type ApprovalsContextApprovalsDataQuery$variables = {
  cloudId: string;
  contentId: string;
  contentStatus: string;
  includeApprovalSettingsConfig: boolean;
  otherContentStatus: string;
  spaceKey: string;
  transitionType?: ConfluenceApprovalTransitionType | null;
};
export type ApprovalsContextApprovalsDataQuery$data = {
  readonly confluence_contentApprovalStatuses: ReadonlyArray<{
    readonly allowsReviews: boolean | null;
    readonly displayProperties: {
      readonly color: string | null;
      readonly name: string | null;
    } | null;
    readonly id: string | null;
  } | null> | null;
  readonly confluence_contentApprovalsSpaceSettingConfig?: {
    readonly config: {
      readonly disallowFirstPublish: boolean;
      readonly enforcedApprovalReviewerConfig: {
        readonly isEnabled: boolean;
        readonly reviewers: ReadonlyArray<{
          readonly principalId: string;
          readonly principalType: ConfluencePrincipalType;
          readonly user: {
            readonly displayName: string | null;
            readonly id: string | null;
            readonly isActive: boolean | null;
            readonly photos: ReadonlyArray<{
              readonly isPrimary: boolean | null;
              readonly value: string | null;
            } | null> | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }>;
    readonly success: boolean;
  } | null;
  readonly confluence_getActiveWorkflowApplication: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }>;
    readonly success: boolean;
    readonly workflowApplication: {
      readonly contentId: string | null;
      readonly contentStatus: string | null;
      readonly contentVersion: number | null;
      readonly creator: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly id: string | null;
      readonly isActive: boolean | null;
      readonly lastModificationDate: {
        readonly value: string;
      } | null;
      readonly modifier: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly workflowId: string | null;
      readonly workflowStatusId: string | null;
    } | null;
    readonly workflowReviewWithDecisions: {
      readonly creationDate: {
        readonly value: string;
      } | null;
      readonly creator: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly creatorAaid: string | null;
      readonly id: string;
      readonly reviewComment: string | null;
      readonly reviewLastModified: {
        readonly value: string;
      } | null;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
      readonly reviewerDecisions: ReadonlyArray<{
        readonly comment: string | null;
        readonly decisionId: string | null;
        readonly lastModifiedDate: {
          readonly value: string;
        } | null;
        readonly principalId: string;
        readonly principalType: ConfluencePrincipalType;
        readonly required: boolean | null;
        readonly reviewerDecisionStatus: ConfluenceReviewerDecisionState | null;
        readonly reviewerId: string | null;
        readonly user: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly isActive: boolean | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly confluence_getActiveWorkflowApplicationForOtherStatus: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }>;
    readonly success: boolean;
    readonly workflowReviewWithDecisions: {
      readonly id: string;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
    } | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly status: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly id: string | null;
    readonly spaceTypeSettings: {
      readonly enabledFeatures: {
        readonly isContentApprovalsEnabled: boolean | null;
      };
    };
  } | null;
};
export type ApprovalsContextApprovalsDataQuery = {
  response: ApprovalsContextApprovalsDataQuery$data;
  variables: ApprovalsContextApprovalsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeApprovalSettingsConfig"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherContentStatus"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transitionType"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "concreteType": "SpaceTypeSettings",
      "kind": "LinkedField",
      "name": "spaceTypeSettings",
      "plural": false,
      "selections": [
        {
          "concreteType": "EnabledFeatures",
          "kind": "LinkedField",
          "name": "enabledFeatures",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isContentApprovalsEnabled"
            }
          ]
        }
      ]
    }
  ]
},
v9 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v10 = [
  (v9/*: any*/),
  {
    "kind": "Literal",
    "name": "filterSelf",
    "value": false
  },
  {
    "kind": "Variable",
    "name": "spaceKey",
    "variableName": "spaceKey"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "success"
},
v12 = {
  "kind": "ScalarField",
  "name": "message"
},
v13 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v14 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v15 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        (v14/*: any*/)
      ]
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "principalType"
},
v17 = {
  "kind": "ScalarField",
  "name": "principalId"
},
v18 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v19 = {
  "kind": "ScalarField",
  "name": "isActive"
},
v20 = {
  "kind": "ScalarField",
  "name": "value"
},
v21 = {
  "kind": "ScalarField",
  "name": "isPrimary"
},
v22 = [
  (v7/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "concreteType": "AtlassianUserPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      (v20/*: any*/),
      (v21/*: any*/)
    ]
  }
],
v23 = {
  "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
  "kind": "LinkedField",
  "name": "config",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "disallowFirstPublish"
    },
    {
      "concreteType": "ConfluenceApprovalReviewerConfig",
      "kind": "LinkedField",
      "name": "enforcedApprovalReviewerConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEnabled"
        },
        {
          "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
          "kind": "LinkedField",
          "name": "reviewers",
          "plural": true,
          "selections": [
            (v16/*: any*/),
            (v17/*: any*/),
            {
              "concreteType": "AtlassianUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": (v22/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v24 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v25 = {
  "kind": "ScalarField",
  "name": "status"
},
v26 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v27 = {
  "args": [
    (v9/*: any*/),
    {
      "kind": "Variable",
      "name": "transitionType",
      "variableName": "transitionType"
    }
  ],
  "concreteType": "ConfluenceApprovalsWorkflowStatus",
  "kind": "LinkedField",
  "name": "confluence_contentApprovalStatuses",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "allowsReviews"
    },
    {
      "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
      "kind": "LinkedField",
      "name": "displayProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        }
      ]
    }
  ]
},
v28 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v29 = {
  "kind": "Literal",
  "name": "fetchWorkflowReview",
  "value": true
},
v30 = {
  "kind": "Literal",
  "name": "workflowId",
  "value": "1"
},
v31 = [
  (v9/*: any*/),
  (v28/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "otherContentStatus"
  },
  (v29/*: any*/),
  (v30/*: any*/)
],
v32 = {
  "kind": "ScalarField",
  "name": "reviewStatus"
},
v33 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v32/*: any*/)
  ]
},
v34 = [
  (v9/*: any*/),
  (v28/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "contentStatus"
  },
  (v29/*: any*/),
  (v30/*: any*/)
],
v35 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v22/*: any*/)
},
v36 = [
  (v20/*: any*/)
],
v37 = {
  "concreteType": "ConfluenceWorkflowApplicationDetails",
  "kind": "LinkedField",
  "name": "workflowApplication",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "workflowId"
    },
    {
      "kind": "ScalarField",
      "name": "contentId"
    },
    {
      "kind": "ScalarField",
      "name": "contentVersion"
    },
    {
      "kind": "ScalarField",
      "name": "contentStatus"
    },
    {
      "kind": "ScalarField",
      "name": "workflowStatusId"
    },
    (v19/*: any*/),
    (v35/*: any*/),
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "lastModificationDate",
      "plural": false,
      "selections": (v36/*: any*/)
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "modifier",
      "plural": false,
      "selections": (v22/*: any*/)
    }
  ]
},
v38 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "creatorAaid"
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "creationDate",
      "plural": false,
      "selections": (v36/*: any*/)
    },
    (v32/*: any*/),
    {
      "kind": "ScalarField",
      "name": "reviewComment"
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "reviewLastModified",
      "plural": false,
      "selections": (v36/*: any*/)
    },
    (v35/*: any*/),
    {
      "concreteType": "ConfluenceReviewerDecisionInfo",
      "kind": "LinkedField",
      "name": "reviewerDecisions",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "decisionId"
        },
        {
          "kind": "ScalarField",
          "name": "reviewerId"
        },
        {
          "kind": "ScalarField",
          "name": "required"
        },
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reviewerDecisionStatus"
        },
        {
          "kind": "ScalarField",
          "name": "comment"
        },
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "lastModifiedDate",
          "plural": false,
          "selections": (v36/*: any*/)
        },
        {
          "concreteType": "AtlassianUser",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            {
              "concreteType": "AtlassianUserPhoto",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": [
                (v21/*: any*/),
                (v20/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v39 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v7/*: any*/)
          ],
          "type": "BulkMutationErrorExtension"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v8/*: any*/),
      {
        "condition": "includeApprovalSettingsConfig",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
            "kind": "LinkedField",
            "name": "confluence_contentApprovalsSpaceSettingConfig",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v15/*: any*/),
              (v23/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v24/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v25/*: any*/),
              (v26/*: any*/)
            ]
          }
        ]
      },
      (v27/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v31/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v15/*: any*/),
          (v33/*: any*/)
        ]
      },
      {
        "args": (v34/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v15/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v8/*: any*/),
      {
        "condition": "includeApprovalSettingsConfig",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
            "kind": "LinkedField",
            "name": "confluence_contentApprovalsSpaceSettingConfig",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v39/*: any*/),
              (v23/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v24/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v25/*: any*/),
              (v26/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      },
      (v27/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v31/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v39/*: any*/),
          (v33/*: any*/)
        ]
      },
      {
        "args": (v34/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v39/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ef0c8a2efcdb424a83f78665f0acae46",
    "id": "985c157aa565f03e81496dc29b329e2ae1f91e0760c67bd74b9fcde8e1c8c447",
    "metadata": {},
    "name": "ApprovalsContextApprovalsDataQuery",
    "operationKind": "query",
    "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalSettingsConfig:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalSettingsConfig){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},config{disallowFirstPublish,enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
  }
};
})();

(node as any).hash = "60b3afeeb98457cbeec75eeea7a52b1e";

export default node;
